import { Identifier } from "../../core";
export class ModifierItemTypeId extends Identifier {
    constructor(id) {
        super("ModifierItemTypeId", id);
    }
}
